import React, { Component } from "react";

import { scrollBy } from "../../../actions/scroll";

import SectionHeader from "../../layout/SectionHeader";
import SecondaryButton from "../../layout/SecondaryButton";

import project_img1_big from "../../layout/assets/keyposer-420-279.jpg";
import project_img1_small from "../../layout/assets/keyposer-200-133.jpg";
import project_img3_big from "../../layout/assets/expensehive-420-280.jpg";
import project_img3_small from "../../layout/assets/expensehive-200-133.jpg";
import project_img4_big from "../../layout/assets/simple_gratitudes-480-280.png";
import project_img4_small from "../../layout/assets/simple_gratitudes-200-133.png";

import WriteUp from "./WriteUp";

import "./styles/About.css";

class About extends Component {
  render() {
    return (
      <main>
        <section className="section-about" id="section-about">
          <SectionHeader title="About" marginBottom="big" />
          <div className="row">
            <div className="col-1-of-2">
              <WriteUp
                show
                title="Me"
                description="My path as a developer began when I used Python to study educational applications during my graduate degree at the University of Victoria. After graduation, I moved on to learn Ruby on Rails, PHP and then NodeJS. I have developed several applications and websites since then and continue to work on both back-end and front-end code for a variety of projects."
              />
              <WriteUp
                show
                title="My Previous Projects"
                description={`Though I have worked on many projects over the last 4 years, I have included Simple Gratitudes, ExpenseHive, and Keyposer on this site to illustrate my diversity of skills. Simple Gratitudes is a side project developed with a simple stack using Supabase and ReactJS. ExpenseHive is a small personal project that uses NodeJS on both ends of the application and Keyposer was a Chrome Extension written entirely using HTML, CSS, and pure JavaScript.`}
              />
              <div className="button-container">
                <SecondaryButton
                  align="center"
                  buttonColour="2"
                  buttonText="Jump to Portfolio &darr;"
                  handleClick={() => {
                    // select id, number of px to add to top of scroll, and delay
                    scrollBy("section-portfolio", 170, 1500);
                  }}
                />
              </div>
            </div>
            <div className="col-1-of-2">
              <div className="composition">
                <img
                  srcSet={`${project_img1_small} 200w, ${project_img1_big} 420w`}
                  sizes="(max-width: 900px) 19vw, (max-width: 600px) 23vw, (max-width: 400) 37vw"
                  alt="Keyposer: Chrome Extension"
                  className="composition__photo composition__photo--p2"
                  src={project_img1_big}
                />
                <img
                  srcSet={`${project_img4_small} 200w, ${project_img4_big} 420w`}
                  sizes="(max-width: 900px) 19vw, (max-width: 600px) 23vw, (max-width: 400) 37vw"
                  alt="Simple Gratitudes: Share your gratitudes"
                  className="composition__photo composition__photo--p1"
                  src={project_img4_big}
                />
                <img
                  srcSet={`${project_img3_small} 200w, ${project_img3_big} 420w`}
                  sizes="(max-width: 900px) 19vw, (max-width: 600px) 23vw, (max-width: 400) 37vw"
                  alt="ExpenseHive: Track Expenses With Ease"
                  className="composition__photo composition__photo--p3"
                  src={project_img3_big}
                />
              </div>
            </div>
          </div>
        </section>
      </main>
    );
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/components/sections/Section-About/About.js